// @flow
import { createContext } from 'react';

interface Context {
  type: string;
  token: ?string;
  setToken: (token: ?string) => void;
  sessionVerified: boolean;
  brokerageId: ?string;
  maximumCommissionRate: number;
}

export const defaultValue = {
  type: 'borrower', // default
  token: (null: ?string),
  sessionVerified: false,
  brokerageId: (null: ?string),
  // eslint-disable-next-line no-unused-vars
  setToken: (_: ?string) => {},
  maximumCommissionRate: (0: number)
};

export const UserContext = createContext<Context>(defaultValue);
